import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SuccessMessage = (message) => {
  setTimeout(
    () =>
      toast.success(message, {
        position: "bottom-center",
        autoClose: 2000,
        theme: "dark",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        transition: Zoom,
      }),
    10
  );
};

const ErrorMessage = (message) => {
  toast.error(message, {
    position: "bottom-center",
    autoClose: 2000,
    theme: "dark",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Zoom,
  });
};


const removeAuth = () => {
  localStorage.removeItem('userData')
  localStorage.removeItem('accessToken');

}

const Apiloader = ({ type }) => {
  return (
    <div className="loading-wrapper">
      <div className="spinner"></div>
      <p className="text-white mt-3">Loading {type}...</p>
    </div>
  );
};

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}


export { ErrorMessage, SuccessMessage, removeAuth, Apiloader };
